import { render, staticRenderFns } from "./ColumnsPage.vue?vue&type=template&id=299ed610&scoped=true&"
import script from "./ColumnsPage.vue?vue&type=script&lang=js&"
export * from "./ColumnsPage.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsPage.vue?vue&type=style&index=0&id=299ed610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ed610",
  null
  
)

export default component.exports